export const socialAuthButtonsStyles = {
  root: 'flex flex-col gap-2',
  button:
    'flex items-center justify-center gap-2 rounded-md border border-border-subtle bg-bg-surface px-4 py-2 text-sm font-medium text-fg-primary transition-base hover:bg-bg-canvas disabled:opacity-50',
  icon: 'h-5 w-5',
  error: 'text-xs text-danger-default',
} as const;
